<template>
  <div class="photo-cell col-12 col-md-6 col-lg-4" :style="{height:photoCellHeight +'px'}" ref="photoCell">
    <div class="photo-cell-inner h-100 p-1">
      <div class="row no-gutters h-100">
        <div class="col text-center h-100">
          <div class="photo-image point-cursor contain" v-lazy:background-image="smallThumbnailUrl" @click="showPhotoImageModal" style="background-position: bottom;"></div>
        </div>
        <div class="col-auto text-center h-100">
          <div class="d-flex flex-column h-100">
            <div class="photo-no text-center mb-auto">{{photo.photo_no}}</div>
            <div class="">
              <i class="fa fa-search-plus image-zoom-btn" aria-hidden="true" @click="showPhotoImageModal"></i>
            </div>
            <div v-if="isDesktop">
              <button class="btn btn-warning favorite-operation" @click="donwloadImage"><trans-text i18nKey="ui['5_4_1'][5]" /> </button>
            </div>
            <div class="text-center">
              <span class="size-info d-inline-block px-1">{{photoSizeMark}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  export default {
    name:"",
    props:["orderPhoto","isDesktop"],

    components: {
    },
    data () {
      return {
        photoCellHeight:null,
        photoImageWrapHeight:null
      }
    },
    watch:{
      "$root.lastAtAdjustLayout"(){
        this.$nextTick()
          .then(()=>{
            this._adjustPhotoCellHeight()
            this.photoImageWrapHeight = 0
            return this.$nextTick()
          }).then(()=>{
          this._adjustphotoImageWrapHeight()
        })
      },
    },
    mounted(){
      this.$nextTick(()=>{
        this._adjustPhotoCellHeight()
        this.$nextTick(()=>{
          this._adjustphotoImageWrapHeight()
        })
      })
    },
    computed:{
      photo(){
        return this.orderPhoto.original_photo
      },
      smallThumbnailUrl(){
        let photo = this.photo
        if(!photo){ return null }
        let photoThumbnail = app.make("_").find(photo.photo_thumbnails,(photo_thumbnail)=>{
          return (String(photo_thumbnail.type_code) === "1")
        })
        return photoThumbnail.image_url + '?token='+store.get("token")
      },
      isMobileBreakpoint(){
        switch(this.$root.bootstrapBreakpoint){
          case "xl":
          case "lg":
            return false
          case "md":
          case "sm":
          case "xs":
            return true
          default:
            return null
        }
      },
      photoSizeMark(){
        let orderPhoto = this.orderPhoto

        if(!orderPhoto){ return "M" }
        let photoSize = orderPhoto.photo_size
        if(!photoSize){
          return "M"
        }
        switch(Number(photoSize.id)){
          case 1:
            return "M"
          case 2:
            return "L"
        }
      },
    },
    methods:{
      //
      _adjustPhotoCellHeight(){
        this.photoCellHeight = $(this.$refs.photoCell).width() / 2
      },
      _adjustphotoImageWrapHeight(){
        this.photoImageWrapHeight = $(this.$refs.photoImageWrap).height()
      },
      donwloadImage(){
        let photo = this.photo
        if(!photo){ return null }

        let photoSize = this.orderPhoto.photo_size
        let photoImage = app.make("_").find(photo.photo_images,(photo_image)=>{
          //return (String(photo_image.type_code) === "1")
          return (String(photo_image.photo_size.code) === String(photoSize.code))
        })
        location.href = photoImage.image_download_url + '?token='+store.get("token")
      },

      //
      showPhotoImageModal(){
        let photoSize = this.orderPhoto.photo_size
        this.$emit("showPhotoImageModal",this.photo,photoSize)
      },
      addCart(){
        this.$emit("addCarPhoto",this.photo)
      },
      removeCart(){
        this.$emit("removeCartPhoto",this.photo)
      }
    }
  }
</script>


<style lang="scss" scoped>
  @import "~scss/_variables";


  .photo-image{
    max-width: 100%;
    max-height: 100%;
  }

  @mixin cart-photo-operation-btn-style {
    font-size:10px;
    padding:2px;
    //          padding:0;
    margin:0;
  }

  .size-info{
    @include cart-photo-operation-btn-style;
    color:#f79a1d;
    font-weight: bold;
    border: 1px #f79a1d solid;
    line-height: 1.25;
    vertical-align: bottom;
  }

  .favorite-operation{
    padding-top:.1rem;
    padding-bottom:.1rem;
    @media(max-width: map-get($grid-breakpoints, "lg") - 1) {
      padding-top:.4rem;
      padding-bottom:.4rem;
    }
  }

  .photo-cell {
    margin-bottom: 2px;

    .photo-cell-inner {
      background-color: #fff;
      border: 2px solid #a8a5a3;
      border-radius: .5rem;
      &.favorite {
        border: 2px solid #ec5c45;
      }
      .photo-no {
        font-size: 0.8rem;
      }
      .image-zoom-btn{
        color: #82ba1d;
        cursor: pointer;
        padding-bottom: .5rem;
        font-size:1.2rem;
        @media(max-width: map-get($grid-breakpoints, "lg") - 1) {
          font-size:2rem;
        }
      }
      .favorite-operation{
        font-size:0.8rem;
        vertical-align: bottom;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// GroupHorizonPhoto.vue?7c0a94a0